<template>
  <Modal2 
    v-if="show" 
    @cancel="close"
    :showTitle="false"
    :showFooter="false"
    className="mail-settings-modal"
  >
     <div class="settings-content">
      <div class="setting-item">
        <div class="setting-label">{{ $t("mail.viewMode") }}</div>
        <div class="setting-control view-mode-options">
          <div
            class="view-mode-option"
            :class="{ active: !isGridMode }"
            @click="setLayoutMode(false)"
          >
            <div class="option-icon no-split">
              <div class="icon-box"></div>
            </div>
            <div class="option-label">{{ $t("mail.singleView") }}</div>
          </div>

          <div
            class="view-mode-option"
            :class="{ active: isGridMode }"
            @click="setLayoutMode(true)"
          >
            <div class="option-icon with-split">
              <div class="split-left"></div>
              <div class="split-right">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
            <div class="option-label">{{ $t("mail.splitView") }}</div>
          </div>
        </div>
      </div>
    </div>
  </Modal2>
</template>

<script>
import Modal2 from "../../../../../components/common/Modal2.vue";

export default {
  name: "MailSettings",
  components: {
    Modal2
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isGridMode: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    setLayoutMode(value) {
      this.$emit('layout-mode-changed', value);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-content {
  padding: 20px;

  .setting-item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .setting-label {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 20px;
      color: #333;
    }

    .setting-control {
      display: flex;
      align-items: center;
    }

    .view-mode-options {
      display: flex;
      gap: 20px;

      .view-mode-option {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 24px 20px;
        border: 2px solid #eaeaea;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s ease;
        height: 180px;

        &:hover {
          background-color: #f9f9f9;
        }

        &.active {
          border-color: #22272d;
          background-color: rgba(34, 39, 45, 0.05);

          .option-label {
            color: #22272d;
            font-weight: 500;
          }
        }

        .option-icon {
          width: 120px;
          height: 90px;
          background-color: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          margin-bottom: 16px;
          display: flex;
          overflow: hidden;

          &.no-split {
            padding: 10px;

            .icon-box {
              width: 100%;
              height: 100%;
              background-color: #eee;
              border-radius: 2px;
            }
          }

          &.with-split {
            display: flex;
            padding: 0;

            .split-left {
              width: 30%;
              height: 100%;
              background-color: #eee;
              flex-shrink: 0;
            }

            .split-right {
              width: 70%;
              height: 100%;
              padding: 10px;
              flex-shrink: 0;

              .line {
                height: 8px;
                background-color: #eee;
                border-radius: 2px;
                margin-bottom: 6px;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }

        .option-label {
          font-size: 16px;
          color: #666;
          text-align: center;
          width: 100%;
          overflow-wrap: break-word;
          word-wrap: break-word;
          margin-top: auto;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .view-mode-options {
    flex-direction: column !important;

    .view-mode-option {
      height: auto !important;
      padding: 16px !important;
    }
  }
}

:deep(.mail-settings-modal) {
  .ant-modal {
    width: 550px !important;
    max-width: 95vw;
  }

  .ant-modal-body {
    overflow: hidden;
  }
}
</style>
